module.exports = __webpack_public_path__ + "experiment.png?3f83fc1dbabfa5cc794e9020119636fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/experiment.png
// module id = 963
// module chunks = 2